<template >
  <div class="userDialog">
    <el-dialog :title="title" :visible.sync="sysDialogVisible" :close-on-click-modal="false" width="500px">
      <el-form ref="userForm" :model="userForm"  label-width="120px" :rules="rules">
        <el-form-item label="用户帐号名"  class="is-required" prop="account" v-if="!this.$props.id">
          <el-input v-model.trim="userForm.account" maxlength="32" placeholder="请输入用户帐号名..." :readonly="this.$props.id!==0"></el-input>
        </el-form-item>
        <el-form-item label="用户真实姓名"  class="is-required" prop="realName" >
          <el-input v-model.trim="userForm.realName" maxlength="32" placeholder="请输入用户真实姓名..."> </el-input>
        </el-form-item>
        <el-form-item label="手机号码"  class="is-required" prop="mobile" v-if="!this.$props.id">
          <el-input v-model.trim="userForm.mobile" maxlength="13" placeholder="请输入手机号码..."> </el-input>
        </el-form-item>
        <el-form-item label="角色"  class="is-required" prop="roleId">
          <el-select v-model="userForm.roleId"  placeholder="请角色类型">
              <el-option
                v-for="item in roles"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="密码"  class="is-required" v-if="!this.$props.id" prop="password">
          <el-input v-model.trim="userForm.password"  placeholder="请输入密码..."> </el-input>
        </el-form-item>
        <el-form-item label="确定密码"  class="is-required" v-if="!this.$props.id" prop="confirmPassword">
          <el-input v-model.trim="userForm.confirmPassword"  placeholder="请再次输入密码..."> </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="sysDialogVisible = false">关闭</el-button>
        <el-button type="primary" @click="save()" v-loading="loading">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script type="text/babel">
import sysService from '@/service/sysService'
export default {
  props: {
    id: {
      type: Number
    },
    dataform: {
      type: Object
    },
    value: {
      type: Boolean,
      default () {
        return false
      }
    }
  },
  data () {
    let validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.userForm.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      title: '新增后台用户',
      loading: false,
      userForm: {
        account: '',
        realName: '',
        mobile: '',
        roleId: '',
        password: '',
        confirmPassword: ''
      },
      roles: [],
      rules: {
        account: [
          {
            required: true,
            message: '请输入用户账户',
            trigger: ['blur', 'change']
          }
        ],
        realName: [
          {
            required: true,
            message: '请输入用户真实姓名',
            trigger: ['blur', 'change']
          }
        ],
        password: [
          {
            required: true,
            message: '请输入密码',
            trigger: ['blur', 'change']
          },
          { min: 6, max: 18, message: '密码长度必修6-18位', trigger: 'blur' }
        ],
        confirmPassword: [
          {
            reqiired: true,
            validator: validatePass2,
            trigger: 'blur'
          }
        ],
        roleId: [
          {required: true, message: '请选择角色', trigger: ['blur', 'change']}
        ],
        mobile: [
          {
            required: true,
            message: '请输入手机号码',
            trigger: ['blur', 'change']
          },
          {validator: this.$rules.phoneNumber, trigger: 'blur'}
        ]
      }
    }
  },
  async mounted () {
    // 用户角色列表
    await this.listUserRole()
  },
  methods: {
    save () {
      this.loading = true
      this.$refs.userForm.validate(async valid => {
        // 验证通过
        if (valid) {
          try {
            // 添加
            if (!this.$props.id) {
              await sysService.saveUser(this.userForm)
            } else {
              await sysService.updateUser(this.$props.id, this.userForm)
            }
            // 重置表单
            this.$refs.userForm.resetFields()
            this.$emit('success')
            this.loading = false
            this.sysDialogVisible = false
          } catch (e) {
            this.loading = false
            this.$message.error(e && e.msg)
          }
        }
        this.loading = false
      })
    },
    async listUserRole () {
      try {
        let data = await sysService.listUserRole()
        if (data) {
          this.roles = data
          this.userForm.roleId = this.roles[0].id
        } else {
          this.roles = []
        }
      } catch (e) {
        this.$message.error(e && e.msg)
      }
    }
  },
  watch: {
    sysDialogVisible (newVal, oldVal) {
      if (newVal) {
        if (this.$refs.userForm) {
          for (let item in this.userForm) {
            this.userForm[item] = ''
          }
        }
        // 加载初始化数据
        if (this.$props.id) {
          this.userForm = {
            realName: '',
            roleId: ''
          }
          this.title = '编辑后台用户'
          let _data = this.$props.dataform
          this.userForm.realName = _data.realName
          this.userForm.roleId = _data.role.id
        } else {
          this.title = '新增后台用户'
        }
      }
    }
  },
  computed: {
    sysDialogVisible: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>
<style scoped>

</style>
<style type="text/css">
 .userDialog .el-input__inner{
   color: #333333;
 }

</style>



// WEBPACK FOOTER //
// src/pages/admin/sys-manage/edit-dialog/index.vue